import { Skeleton } from "@mui/material";

function CustomTextSkeleton({ sx = [], ...props }) {
  return (
    <Skeleton
      variant="text"
      sx={[...(Array.isArray(sx) ? sx : [sx])]}
      {...props}
    />
  );
}

export default CustomTextSkeleton;
